export default {
	'zotero.appName': 'Zotero',
	'general.etAl': 'et al.',
	'general.back': 'Back',
	'general.thanksForHelpingImprove': 'Thanks for helping to improve %S!',
	'general.tryAgain': 'Try Again',
	'general.updateAvailable': 'Update Available',
	'general.copyToClipboard': 'Copy to Clipboard',
	'general.finished': 'Finished',
	'general.checkForUpdates': 'Check for Updates',
	'general.keys.cmdShift': 'Cmd+Shift+',
	'general.clear': 'Clear',
	'general.failed': 'Failed',
	'general.restartLater': 'Restart later',
	'general.unknownErrorOccurred': 'An unknown error occurred.',
	'general.dontShowAgainFor': 'Don’t show again today;Don’t show again for %1$S days',
	'general.permissionDenied': 'Permission Denied',
	'general.checkForUpdate': 'Check for Update',
	'general.moreInformation': 'More Information',
	'general.quitApp': 'Quit %S',
	'general.errorHasOccurred': 'An error has occurred.',
	'general.and': 'and',
	'general.isUpToDate': '%S is up to date.',
	'general.seeForMoreInformation': 'See %S for more information.',
	'general.success': 'Success',
	'general.submitted': 'Submitted',
	'general.character.plural': 'characters',
	'general.locate': 'Locate…',
	'general.restartNow': 'Restart now',
	'general.pleaseRestart': 'Please restart %S.',
	'general.quit': 'Quit',
	'general.hide': 'Hide',
	'general.browserIsOffline': '%S is currently in offline mode.',
	'general.error': 'Error',
	'general.import': 'Import',
	'general.warning': 'Warning',
	'general.yes': 'Yes',
	'general.useDefault': 'Use Default',
	'general.fix': 'Fix…',
	'general.restartRequiredForChanges': '%S must be restarted for the changes to take effect.',
	'general.accessDenied': 'Access Denied',
	'general.continue': 'Continue',
	'general.dontShowAgain': 'Don’t Show Again',
	'general.copy': 'Copy',
	'general.keys.ctrlShift': 'Ctrl+Shift+',
	'general.close': 'Close',
	'general.create': 'Create',
	'general.export': 'Export',
	'general.noUpdatesFound': 'No Updates Found',
	'general.restartRequired': 'Restart Required',
	'general.actionCannotBeUndone': 'This action cannot be undone.',
	'general.pdf': 'PDF',
	'general.remove': 'Remove',
	'general.cancel': 'Cancel',
	'general.tryLater': 'Try Later',
	'general.operationInProgress.waitUntilFinishedAndTryAgain': 'Please wait until it has finished and try again.',
	'general.processing': 'Processing',
	'general.disable': 'Disable',
	'general.restartApp': 'Restart %S',
	'general.enable': 'Enable',
	'general.showDirectory': 'Show Directory',
	'general.passed': 'Passed',
	'general.invalidResponseServer': 'Invalid response from server.',
	'general.reset': 'Reset',
	'general.nMegabytes': '%S MB',
	'general.numMore': '%S more…',
	'general.serverError': 'The server returned an error. Please try again.',
	'general.upgrade': 'Upgrade',
	'general.open': 'Open %S',
	'general.openPreferences': 'Open Preferences',
	'general.describeProblem': 'Briefly describe the problem:',
	'general.pleaseRestartAndTryAgain': 'Please restart %S and try again.',
	'general.operationInProgress.waitUntilFinished': 'Please wait until it has finished.',
	'general.dontShowWarningAgain': 'Don\'t show this warning again.',
	'general.notNow': 'Not Now',
	'general.item': 'Item',
	'general.restartRequiredForChange': '%S must be restarted for the change to take effect.',
	'general.character.singular': 'character',
	'general.operationInProgress': 'A Zotero operation is currently in progress.',
	'general.no': 'No',
	'general.delete': 'Delete',
	'general.openDocumentation': 'Open Documentation',
	'general.tryAgainLater': 'Please try again in a few minutes.',
	'general.install': 'Install',
	'general.yellow': 'Yellow',
	'general.red': 'Red',
	'general.green': 'Green',
	'general.blue': 'Blue',
	'general.purple': 'Purple',
	'general.magenta': 'Magenta',
	'general.orange': 'Orange',
	'general.gray': 'Gray',
	'general.black': 'Black',
	'general.showInLibrary': 'Show in Library',
	'general.clearSelection': 'Clear Selection',
	'general.update': 'Update',
	'general.print': 'Print',
	'pdfReader.annotations': 'Annotations',
	'pdfReader.showAnnotations': 'Show Annotations',
	'pdfReader.searchAnnotations': 'Search Annotations',
	'pdfReader.searchOutline': 'Search Outline',
	'pdfReader.noAnnotations': 'Create an annotation to see it in the sidebar',
	'pdfReader.noExtractedText': 'No extracted text',
	'pdfReader.addComment': 'Add comment',
	'pdfReader.annotationComment': 'Annotation comment',
	'pdfReader.annotationText': 'Annotation text',
	'pdfReader.manageTags' : 'Manage tags for this annotation',
	'pdfReader.openMenu' : 'Open annotation menu',
	'pdfReader.thumbnails' : 'Thumbnails',
	'pdfReader.tagSelectorMessage' : 'Filter annotations by this tag',
	'pdfReader.addTags': 'Add tags…',
	'pdfReader.highlightText': 'Highlight Text',
	'pdfReader.underlineText': 'Underline Text',
	'pdfReader.addNote': 'Add Note',
	'pdfReader.selectArea': 'Select Area',
	'pdfReader.addText': 'Add Text',
	'pdfReader.draw': 'Draw',
	'pdfReader.highlightAnnotation' : 'Highlight annotation',
	'pdfReader.underlineAnnotation' : 'Underline annotation',
	'pdfReader.noteAnnotation' : 'Note annotation',
	'pdfReader.textAnnotation' : 'Text annotation',
	'pdfReader.imageAnnotation' : 'Image annotation',
	'pdfReader.inkAnnotation' : 'Ink annotation',
	'pdfReader.searchResultIndex' : 'Search result',
	'pdfReader.searchResultTotal' : 'Total search results',
	'pdfReader.eraser': 'Eraser',
	'pdfReader.pickColor': 'Pick a Color',
	'pdfReader.addToNote': 'Add to Note',
	'pdfReader.zoomIn': 'Zoom In',
	'pdfReader.zoomOut': 'Zoom Out',
	'pdfReader.zoomReset': 'Reset Zoom',
	'pdfReader.zoomAuto': 'Automatically Resize',
	'pdfReader.zoomPageWidth': 'Zoom to Page Width',
	'pdfReader.zoomPageHeight': 'Zoom to Page Height',
	'pdfReader.splitVertically': 'Split Vertically',
	'pdfReader.splitHorizontally': 'Split Horizontally',
	'pdfReader.nextPage': 'Next Page',
	'pdfReader.previousPage': 'Previous Page',
	'pdfReader.page': 'Page',
	'pdfReader.location': 'Location',
	'pdfReader.readOnly': 'Read-only',
	'pdfReader.promptTransferFromPDF.title': 'Import Annotations',
	'pdfReader.promptTransferFromPDF.text': 'Annotations stored in the PDF file will be moved to %1$S.',
	'pdfReader.promptTransferToPDF.title': 'Store Annotations in File',
	'pdfReader.promptTransferToPDF.text': 'Annotations will be transferred to the PDF file and will no longer be editable in %S.',
	'pdfReader.promptPasswordProtected': 'The operation is not supported for password-protected PDF files.',
	'pdfReader.rotateLeft': 'Rotate Left',
	'pdfReader.rotateRight': 'Rotate Right',
	'pdfReader.editPageNumber': 'Edit Page Number…',
	'pdfReader.editAnnotationText': 'Edit Annotation Text',
	'pdfReader.copyImage': 'Copy Image',
	'pdfReader.saveImageAs': 'Save Image As…',
	'pdfReader.pageNumberPopupHeader': 'Change page number for:',
	'pdfReader.thisAnnotation': 'This annotation',
	'pdfReader.selectedAnnotations': 'Selected annotations',
	'pdfReader.thisPage': 'This page',
	'pdfReader.thisPageAndLaterPages': 'This page and later pages',
	'pdfReader.allPages': 'All pages',
	'pdfReader.autoDetect': 'Auto-Detect',
	'pdfReader.epubAppearance': 'Appearance',
	'pdfReader.epubAppearance.lineHeight': 'Line height',
	'pdfReader.epubAppearance.wordSpacing': 'Word spacing',
	'pdfReader.epubAppearance.letterSpacing': 'Letter spacing',
	'pdfReader.epubAppearance.pageWidth': 'Page width',
	'pdfReader.epubAppearance.useOriginalFont': 'Use original font',
	'pdfReader.epubAppearance.lineHeight.revert': 'Use default line height',
	'pdfReader.epubAppearance.wordSpacing.revert': 'Use default word spacing',
	'pdfReader.epubAppearance.letterSpacing.revert': 'Use default letter spacing',
	'pdfReader.epubAppearance.pageWidth.revert': 'Use default page width',
	'pdfReader.deleteAnnotation.singular': 'Are you sure you want to delete the selected annotation?',
	'pdfReader.deleteAnnotation.plural': 'Are you sure you want to delete the selected annotations?',
	'pdfReader.enterPassword': 'Enter the password to open this PDF file.',
	'pdfReader.includeAnnotations': 'Include annotations',
	'pdfReader.preparingDocumentForPrinting': 'Preparing document for printing…',
	'pdfReader.phraseNotFound': 'Phrase not found',
	'pdfReader.selectedPages': '{count, plural, one {# page} other {# pages}} selected',
	'pdfReader.pageOptions': 'Page Options',
	'pdfReader.epubEncrypted': 'This ebook appears to be encrypted and cannot be opened.',
	'pdfReader.find': 'Find',
	'pdfReader.close': 'Close',
	'pdfReader.showThumbnails': 'Show Thumbnails',
	'pdfReader.showOutline': 'Show Outline',
	'pdfReader.findPrevious': 'Find the previous occurrence of the phrase',
	'pdfReader.findNext': 'Find the next occurrence of the phrase',
	'pdfReader.toggleSidebar': 'Toggle Sidebar',
	'pdfReader.findInDocument': 'Find in Document',
	'pdfReader.toggleContextPane': 'Toggle Context Pane',
	'pdfReader.highlightAll': 'Highlight all',
	'pdfReader.matchCase': 'Match case',
	'pdfReader.wholeWords': 'Whole words',
	'pdfReader.convertToHighlight': 'Convert to Highlight',
	'pdfReader.convertToUnderline': 'Convert to Underline',
	'pdfReader.size': 'Size',
	'pdfReader.merge': 'Merge',
	'pdfReader.copyLink': 'Copy Link',
};
